import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageLoader from '../../Components/PageLoader';
import PageHeading from '../../Components/PageHeading';
import SelectCampaign from '../../Components/SelectCampaign';
import CampaignEmptyState from '../../Components/CampaignEmptyState';
import CultService from '../../Services/CultService';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import { FiChevronDown } from 'react-icons/fi';
import { AppColors } from '../../Utils/helper/AppColors';
import MentionProgress from './Components/MentionProgress';
import DataNotFound from '../../Components/DataNotFound';
import { theme } from 'antd';

export default function CampaignInsights() {
	const [loading, setLoading] = useState(false);
	const [filterQuery, setFilterQuery] = useState(null);
	const company = useSelector((state) => state?.app?.company);
	const [insights, setInsights] = useState([]);

	const handleSelectCampaign = (i, option) => {
		setFilterQuery((prev) => ({ ...prev, campaigns: [option?.item] }));
	};

	const getCampaignInsights = async () => {
		setLoading(true);
		try {
			let res = await CultService.getCampaignInsightsV2({
				params: {
					companyId: company?._id,
					campaigns: filterQuery?.campaigns?.map((i) => i._id),
				},
			});
			setInsights(res.data.data);
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (company) {
			if (filterQuery?.campaigns?.length > 0) {
				getCampaignInsights();
			}
		}
	}, [company, filterQuery]);

	return (
		<Stack sx={{ padding: 2 }} gap={3}>
			{loading && <PageLoader />}
			<PageHeading
				title="Campaign Insights"
				// subTitle="Track, manage and forecast your employee mindset"
			/>

			{/* <Typography variant="h3">Campaign Insights</Typography> */}
			<Box>
				<Stack gap={2}>
					<SelectCampaign handleSelectCampaign={handleSelectCampaign} width={'488px'} />
					{filterQuery?.campaigns?.length > 0 ? (
						insights?.length > 0 ? (
							insights?.map((insight) => (
								<>
									{insight?.subTopic?.map((sub, index) => (
										<Stack
											key={index}
											direction="column"
											gap={1}
											sx={(theme) => ({
												backgroundColor: AppColors.WHITE,
												borderRadius: '10px',
												border: `1px solid ${theme.palette.primary.light_shade}`,
											})}
										>
											<Stack
												direction="row"
												justifyContent="space-between"
												alignItems="center"
												sx={theme => ({ padding: 2, borderBottom: `1px solid ${theme.palette.primary.light_shade}` })}
											>
												<Typography
													textTransform="capitalize"
													fontFamily={'Poppins'}
													fontSize={18}
													fontWeight={600}
													lineHeight={'150%'}
													color={AppColors.HEADING_TITLE}
												>
													{sub.name}
												</Typography>
											</Stack>

											<TableContainer sx={{ border: 'none' }}>
												<Table sx={{ width: '96%', margin: '0 auto' }}>
													{/* <TableHead>
													<TableCell colSpan={3}>
														<Typography textTransform="capitalize" variant="subtitle1">
															{sub?.name}
														</Typography>
													</TableCell>
												</TableHead> */}
													<TableHead
														sx={{
															'& .MuiTableCell-root': {
																fontSize: 12,
																color: AppColors.TEXT_TERTIARY,
																fontWeight: 500,
																paddingLeft: 0,
															},
														}}
													>
														<TableCell
															sx={{
																fontWeight: 600,
																fontFamily: 'Poppins',
																lineHeight: '150%',
																fontSize: 14,
																color: AppColors.HEADING_TITLE2,
															}}
															width="44%"
														>
															Insights
														</TableCell>
														<TableCell
															sx={{
																fontWeight: 600,
																fontFamily: 'Poppins',
																lineHeight: '150%',
																fontSize: 14,
																color: AppColors.HEADING_TITLE2,
															}}
															width="44%"
														>
															Recommended Action
														</TableCell>
														{/* <TableCell>Mentions</TableCell> */}
													</TableHead>

													<TableBody sx={{ '& .MuiTableCell-root': { paddingLeft: 0, verticalAlign: 'top' } }}>
														{sub?.cluster?.map((mention) => (
															<TableRow>
																<TableCell>
																	<Typography
																		sx={{
																			fontWeight: 400,
																			fontFamily: 'Poppins',
																			lineHeight: '150%',
																			fontSize: 14,
																			color: AppColors.HEADING_TITLE3,
																		}}
																	>
																		{mention?.cluster?.issue || '--'}
																	</Typography>
																</TableCell>
																<TableCell>
																	<Typography
																		sx={{
																			fontWeight: 400,
																			fontFamily: 'Poppins',
																			lineHeight: '150%',
																			fontSize: 14,
																			color: AppColors.HEADING_TITLE2,
																		}}
																	>
																		{mention?.cluster?.solution || '--'}
																	</Typography>
																</TableCell>
																{/* <TableCell>
																<MentionProgress value={parseInt(mention?.reported?.replace('%', ''))} />
															</TableCell> */}
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										</Stack>
									))}
								</>
							))
						) : (
							<Stack sx={{ height: 'calc(100vh - 170px)', backgroundColor: AppColors.WHITE, borderRadius: '10px' }}>
								<DataNotFound />
							</Stack>
						)
					) : (
						<CampaignEmptyState text="Select a campaign to view campaign insights." />
					)}
				</Stack>
			</Box>
		</Stack>
	);
}
